var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"clearfix col-xs-12"},[_c('p',{staticClass:"signature text-right small mr-2"},[_c('span',{domProps:{"textContent":_vm._s(`${_vm.$t('meta.start')} ${_vm.$t('meta.date-start')}`)}}),_vm._v(" "),_c('br'),_vm._v(" "),_c('span',{domProps:{"textContent":_vm._s(`${_vm.$t('meta.edit')} ${_vm.$t('meta.date-edit')}`)}})])])
}
var staticRenderFns = []

export { render, staticRenderFns }